module.exports = __webpack_public_path__ + "static/media/02-2-galeria-01-salon-de-escritura-mobile@2x.962a81a8.jpg";